export const FILTERING_OPERATORS_FOR_STRING = [":", "!:", "=", "!="];
export const FILTERING_OPERATORS_FOR_NUMBER = ["=", "!=", ">", "<", ">=", "<="];

export const PAGE_SIZE_OPTIONS = [
    {value: 100, label: "100 Journal Lines"},
    {value: 500, label: "500 Journal Lines"},
    {value: 1000, label: "1000 Journal Lines"},
];
